export { default as flowRecord } from './components/flowRecord';
export { default as FlowAction } from './components/flowAction';
const bizCssPrefix = 'bizpack';
export { bizCssPrefix };
